// Hero image used on /pricing.
// Previously a demographic-aware picker, now a single curated photo for everyone.

export const HERO_IMAGE = {
  src: 'https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=crop&w=1200&q=80',
  alt: 'A person celebrating success',
};
